<template>
  <div class="personal-main">
    <Header />
    <div class="main-1200-width padding-bottom-40">
      <div class="bread-nav">
        <a href="/"> 首页</a>><span class="red">个人信息</span>
      </div>
      <div class="main">
        <div class="main-left">
          <div class="left-line " :class="active == 0 ? 'active' : ''">
            <router-link to="/PerSonalLayout/PerSonalInfo">
              <i class="iconfont icon-gerenxinxi"></i>
              个人信息
            </router-link>
          </div>
          <div class="left-line" :class="active == 1 ? 'active' : ''">
            <router-link to="/PerSonalLayout/MyOrder">
              <i class="iconfont icon-icon2"></i>
              我的订单
            </router-link>
          </div>
          <div class="left-line" :class="active == 2 ? 'active' : ''">
            <router-link to="/PerSonalLayout/MyContract">
              <i class="iconfont icon-hetong"></i>
              我的合同
            </router-link>
          </div>
          <div class="left-line" :class="active == 3 ? 'active' : ''">
            <router-link to="/PerSonalLayout/MyAddress">
              <i class="iconfont icon-hetong"></i>
              收件地址
            </router-link>
          </div>
          <div class="left-line" :class="active == 4 ? 'active' : ''">
            <router-link to="/PerSonalLayout/MyInstitution">
              <i class="iconfont icon-hetong"></i>
              开票信息
            </router-link>
          </div>
          <div class="left-line" :class="active == 5 ? 'active' : ''">
            <router-link to="/PerSonalLayout/MyLike">
              <i class="iconfont icon-shoucang"></i>
              我的收藏
            </router-link>
          </div>
          <div class="left-line">
            <a @click="logout" style="cursor:pointer">
              <i class="iconfont icon-zhuxiao"></i>
              注销登陆
            </a>
          </div>
        </div>
        <div class="main-right">
          <router-view @getCompontsIndex="getCompontsIndex" />
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from "@/globalComponents/Header";
import Footer from "@/globalComponents/Footer";
export default {
  data() {
    return {
      active: 0
    };
  },
  created() {},
  methods: {
    async logout() {
      await this.$store.commit("user/Logout");
      this.$message({
        type:"success",
        message:"注销成功"
      });
      location.href="/login"
    },
    getCompontsIndex(e) {
      this.active = e;
    }
  },
  components: {
    Header,
    Footer
  }
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/components/personal-info/index.vue